import React from "react"

import { joinClasses, useClasses } from "../globals";

import {
  Box,
  Collapse,
  Link,
  Typography
} from "@material-ui/core"
import { Alert } from "@material-ui/lab"


export const AuthoringForbidden = ({ email }) => {
  const classes = useClasses()

  return (
    <React.Fragment>
      <Box
        className={joinClasses(
          classes._Padding,
          classes._Flex,
          classes._FlexDirectionColumn
        )}
      >
        <Box className={classes._Margin}>
          <Collapse in>
            <Alert severity="error">
              <Typography>
                You do not have permission to access this application.
              </Typography>
            </Alert>
          </Collapse>
        </Box>
      </Box>
    </React.Fragment>
  )
}

AuthoringForbidden.title = "Forbidden";